import { Injectable } from "@angular/core";

declare const window: any;

@Injectable({
  providedIn: "root"
})
export class HotjarService {
  initialize(siteId: number, version: number) {
    window.hj =
      window.hj ||
      function () {
        (window.hj.q = window.hj.q || []).push(arguments);
      };
    window._hjSettings = { hjid: siteId, hjsv: version };

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://static.hotjar.com/c/hotjar-" + siteId + ".js?sv=" + version;
    document.head.appendChild(script);
  }
}
